"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/InfoTab/InfoSection/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);






var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);
var _noticeBar = require('web/services/context/noticeBar');
var _phone = require('shared/services/phone');
var _time = require('shared/services/time');

var _components = require('web/screens/Directory/components');
var _ExportPhoneLogsModal = require('web/screens/Directory/TeamPage/ExportPhoneLogsModal'); var _ExportPhoneLogsModal2 = _interopRequireDefault(_ExportPhoneLogsModal);
var _EditInfoModal = require('./EditInfoModal'); var _EditInfoModal2 = _interopRequireDefault(_EditInfoModal);












const InfoSection = ({
  teamKey,
  teamName,
  phoneNumber,
  orgKey,
  orgName,
  canEditTeam,
  canExportPhoneLogs,
  onUpdateInfo,
}) => {
  const {
    isOpen: isEditModalOpen,
    onOpen: onEdit,
    onClose: onCloseEditModal,
  } = _useToggle2.default.call(void 0, )
  const {
    isOpen: isExportPhoneLogsModalOpen,
    onOpen: onOpenExportPhoneLogsModal,
    onClose: onCloseExportPhoneLogsModal,
  } = _useToggle2.default.call(void 0, )

  const { showWarningBar, showSuccessBar } = _noticeBar.useNoticeBar.call(void 0, )

  const onExportPhoneLogs = _react.useCallback.call(void 0, 
    async (FromDate, ToDate) => {
      showSuccessBar('Export has been requested')
      return _actions2.default.exportPhoneLogs({
        OrgKey: orgKey,
        FromNumber: phoneNumber || '',
        FromDate,
        ToDate,
        TimeZone: _time.userTZ ,
      })
        .then(link => window.open(link, "_self"))
        .catch(() => showWarningBar('Failed to export phone logs'))
    },
    [orgKey, phoneNumber, showWarningBar, showSuccessBar],
  )

  const handleSubmit = _react.useCallback.call(void 0, 
    (data) => onUpdateInfo(data)
      .then(onCloseEditModal)
      .then(() => showSuccessBar('Successfully updated team information'))
      .catch(() => showWarningBar('Failed to update team information')),
    [onUpdateInfo, onCloseEditModal, showWarningBar, showSuccessBar],
  )

  return (
    _react2.default.createElement('div', { className: "team-page--card team-page--info" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
      , _react2.default.createElement('div', { className: "team-page--info--row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
        , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
          , _react2.default.createElement('div', { className: "team-page--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}, "Team")
          , _react2.default.createElement('div', { className: "team-page--info--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}},  teamName )
          , _react2.default.createElement('div', { className: "team-page--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}},  orgName )
        )
        ,  canEditTeam && (
          _react2.default.createElement(_components.InfoBtn, {
            label: "Edit details" ,
            iconSrc: "/assets/icons/icon-edit-purple.svg",
            onClick: onEdit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}
          )
        )
      )
      ,  phoneNumber && (
        _react2.default.createElement('div', { className: "team-page--info--row team-page--info--row--number" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}
          , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}
            , _react2.default.createElement('div', { className: "team-page--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}, "Team number" )
            , _react2.default.createElement('div', { className: "team-page--info--number", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}},  _phone.formatPhoneNumber.call(void 0, phoneNumber) )
          )
          ,  canExportPhoneLogs && (
            _react2.default.createElement(_components.InfoBtn, {
              label: "Export SMS logs"  ,
              iconSrc: "/assets/icons/icon-download-purple.svg",
              onClick: onOpenExportPhoneLogsModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}
            )
          )
        )
      )
      , _react2.default.createElement(_EditInfoModal2.default, {
        teamKey: teamKey,
        isOpen: isEditModalOpen,
        onClose: onCloseEditModal,
        onSubmit: handleSubmit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}
      )
      , _react2.default.createElement(_ExportPhoneLogsModal2.default, {
        isOpen: isExportPhoneLogsModalOpen,
        onClose: onCloseExportPhoneLogsModal,
        onProceed: onExportPhoneLogs, __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}
      )
    )
  )
}

exports. default = InfoSection
